import { useEffect, useRef } from 'react';
import mixpanel from '@/utils/mixpanel';

/**
 * Fires 'Upgrade Path Modal Viewed' exactly once per modal open session.
 * Uses upgradeContext object identity to detect new opens; resets when modal closes.
 *
 * @param {boolean} isOpen
 * @param {object|null} upgradeContext - modalStore.upgradeContext (new ref each open)
 * @param {object} trackingProps - properties to include with the Mixpanel event
 */
export default function useTrackModalViewed(isOpen, upgradeContext, trackingProps) {
  const viewedContextRef = useRef(null);
  const trackingPropsRef = useRef(trackingProps);
  trackingPropsRef.current = trackingProps;

  useEffect(() => {
    if (isOpen && upgradeContext && upgradeContext !== viewedContextRef.current) {
      viewedContextRef.current = upgradeContext;
      mixpanel.track('Upgrade Path Modal Viewed', trackingPropsRef.current);
    }
    if (!isOpen) {
      viewedContextRef.current = null;
    }
  }, [isOpen, upgradeContext]);
}
